import React from 'react';

type StatusType =
  | 'New' | 'In Progress' | 'Awaiting Citizen' | 'Awaiting Agency' | 'Resolved' | 'Closed' |'Available'| 'Busy' | 'Away' | 'Offline' |'Active' | 'Ended' | 'Pending';

const statusConfig: Record<string, { bg: string; text: string }> = {
  'New': { bg: 'bg-blue-50', text: 'text-blue-700' },
  'In Progress': { bg: 'bg-amber-50', text: 'text-amber-700' },
  'Awaiting Citizen': { bg: 'bg-purple-50', text: 'text-purple-700' },
  'Awaiting Agency': { bg: 'bg-orange-50', text: 'text-orange-700' },
  'Resolved': { bg: 'bg-green-50', text: 'text-green-700' },
  'Closed': { bg: 'bg-slate-100', text: 'text-slate-600' },
  'Available': { bg: 'bg-green-50', text: 'text-green-700' },
  'Busy': { bg: 'bg-red-50', text: 'text-red-700' },
  'Away': { bg: 'bg-amber-50', text: 'text-amber-700' },
  'Offline': { bg: 'bg-slate-100', text: 'text-slate-500' },
  'Active': { bg: 'bg-blue-50', text: 'text-blue-700' },
  'Ended': { bg: 'bg-slate-100', text: 'text-slate-600' },
  'Pending': { bg: 'bg-amber-50', text: 'text-amber-700' },
};

interface StatusBadgeProps {
  status: string;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const config = statusConfig[status] || { bg: 'bg-slate-100', text: 'text-slate-600' };
  return (
    <span className={`inline-flex items-center rounded-full font-500 ${config.bg} ${config.text} ${size === 'sm' ? 'text-[11px] px-2 py-0.5' : 'text-xs px-2.5 py-1'}`}>
      {status}
    </span>
  );
}